import { PARTNER_THEME_URL } from './themes.constants';
import { Brand, PartnerUrl } from './themes.types';

export const isPartnerBrand = (brand: Brand): boolean =>
  [Brand.AKADEMIKERNE, Brand.COOP, Brand.DANSKE_BANK].includes(brand);

export const applyPartnerTheme = (brand: Brand): void => {
  if (brand === Brand.STB) {
    return;
  }

  const href = PARTNER_THEME_URL[brand];

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
};

export const getPartnerBrandFromBaseUrl = (baseUrl: string): Brand => {
  switch (baseUrl) {
    case PartnerUrl.AKADEMIKERNE:
      return Brand.AKADEMIKERNE;
    case PartnerUrl.COOP:
      return Brand.COOP;
    case PartnerUrl.DANSKE_BANK:
      return Brand.DANSKE_BANK;
    default:
      return Brand.STB;
  }
};

export const isDanskeBankBrand = (brand: Brand): boolean =>
  brand === Brand.DANSKE_BANK;

export const isCoopBrand = (brand: Brand): boolean => brand === Brand.COOP;

export const isAkademikerneBrand = (brand: Brand): boolean =>
  brand === Brand.AKADEMIKERNE;

export const isHuseierneBrand = (brand: Brand): boolean =>
  brand === Brand.HUSEIERNE;
